import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { GetError500Response } from './types';

export const getError500 = async (lang = 'en') => {
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/errors/500?${queryParams.join('&')}`, {
		method: 'GET',
		credentials: 'include',
	})
	.then((res) => {
		if (res.ok) return res.json() as Promise<GetError500Response>;
	})
	.catch((error) => {
		console.error('Error 500 request error: ', error);
		throw error;
	});
};
